export default __webpack_public_path__ + "static/media/Background_00105.736e41b9.png";